module.exports = __webpack_public_path__ + "img/heart.9aa5d4d.png";